import { Outlet } from 'react-router-dom'
import { useT } from '../i18n/context'
import type { DictPath } from '../i18n/translate'
import { PageTabs, type PageTabItem } from './PageTabs'

/**
 * Rahmen für Gruppen-Seiten (Abrechnung, Workspace): Gruppenkopf mit Titel
 * und Untertitel, darunter die Tab-Leiste und der Inhalt der Sub-Route.
 */
export function GroupPageLayout({
    titleKey,
    subtitleKey,
    tabs,
}: {
    titleKey: DictPath
    subtitleKey?: DictPath
    tabs: readonly PageTabItem[]
}) {
    const t = useT()
    return (
        <div className='space-y-4'>
            <div>
                <h1 className='text-xl font-bold text-slate-800 dark:text-slate-100'>
                    {t(titleKey)}
                </h1>
                {subtitleKey && (
                    <p className='mt-0.5 text-sm text-slate-500 dark:text-slate-400'>
                        {t(subtitleKey)}
                    </p>
                )}
            </div>
            <PageTabs tabs={tabs} />
            <Outlet />
        </div>
    )
}
